

export const PHONE_REGEXP = /^(\+?1\s?)?(\([0-9]{3}\)|[0-9]{3})[-.\s]?[0-9]{3}[-.\s]?[0-9]{4}$/

export const phoneDigits = value =>
  String(value ?? '')
    .replace(/\D/g, '')
    .slice(0, 10)

export const formatPhoneInput = value => {
  const digits = phoneDigits(value)
  if (digits.length < 4) return digits
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}

export const formatPhone = (value, fallback = '') => {
  if (!value) return fallback
  const digits = phoneDigits(value)
  return digits.length === 10 ? formatPhoneInput(digits) : value
}

export const sequencePhones = phones => {
  const list = phones ?? []
  return [...list.filter(phone => phone?.type === 'mobile'), ...list.filter(phone => phone?.type !== 'mobile')].map(
    (phone, index) => ({ ...phone, seq: index + 1 }),
  )
}
